import { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";
import Logo from "../../components/Logo";

export default function AdminResetPassword() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (loading) return;
        if (password !== confirm) {
            toast.error("Passwords don't match");
            return;
        }
        if (password.length < 8) {
            toast.error("Password must be at least 8 characters");
            return;
        }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: password });
            toast.success("Password updated — you can now log in");
            navigate("/admin/login");
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="min-h-screen bg-[#FFF7FB] flex items-center justify-center px-4 py-16" data-testid="admin-reset-password-page">
            <div className="w-full max-w-md bg-white border border-blush/20 p-8 md:p-10 shadow-[0_30px_80px_rgba(236,0,140,0.15)]">
                <Link to="/" className="block mb-6">
                    <Logo variant="dark" className="h-12 mx-auto" />
                </Link>
                <h1 className="font-display text-3xl text-ink mb-2 text-center">Set New Password</h1>
                <p className="text-sm text-ink-soft mb-8 text-center">Cake Central CMS</p>
                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">New Password</label>
                        <input
                            type="password"
                            required
                            minLength={8}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-3 border border-[#EAE3DE] focus:outline-none focus:border-blush"
                            data-testid="reset-password-new"
                        />
                    </div>
                    <div>
                        <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">Confirm Password</label>
                        <input
                            type="password"
                            required
                            minLength={8}
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            className="w-full px-4 py-3 border border-[#EAE3DE] focus:outline-none focus:border-blush"
                            data-testid="reset-password-confirm"
                        />
                    </div>
                    <button type="submit" disabled={loading} className="btn-pink w-full disabled:opacity-60" data-testid="reset-password-submit">
                        {loading ? "Updating…" : "Update password"}
                    </button>
                </form>
            </div>
        </main>
    );
}
